import { render, staticRenderFns } from "./frequently-asked-questions.vue?vue&type=template&id=0e51d823&scoped=true&"
import script from "./frequently-asked-questions.vue?vue&type=script&lang=ts&"
export * from "./frequently-asked-questions.vue?vue&type=script&lang=ts&"
import style0 from "./frequently-asked-questions.vue?vue&type=style&index=0&id=0e51d823&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e51d823",
  null
  
)

export default component.exports